export enum DirectoryEditAction {
  editRoom = "editRoom",
  editHotel = "editHotel",
  editRegion = "editRegion",
  editTour = "editTour",
}
